module.exports = "<i class=\"icon-loading spin fg-funkyOrange header\"></i>\n"